import { css } from "linaria";

export const cell = css`
  height: var(--space-300);
`;

export const doubleCell = css`
  height: var(--space-600);
`;